module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_vm._v("\n    " + _vm._s(_vm.address ? _vm.$lang.actions.edit : _vm.$lang.actions.add) + " " + _vm._s(_vm.$lang.actions.address) + "\n  ")]), _vm._v(" "), _c('v-card-text', [(!_vm.isLoading) ? _c('div', {
    staticClass: "py-1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n       \n    ")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('v-progress-linear', {
    staticClass: "my-3",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filteredLines), function(line, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "px-2 prefill",
      class: {
        'd-none': ['latitude', 'longitude'].includes(line.property)
      },
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-wrap",
      attrs: {
        "label": line.label,
        "rules": line.required ? _vm.required : [],
        "type": ['latitude', 'longitude'].includes(line.property) ? 'number' : 'text',
        "color": "primary",
        "id": String(index),
        "hint": line.property === 'line1' && _vm.formData[line.property] === '' ? _vm.$lang.labels.startTyping : '',
        "persistent-hint": ""
      },
      on: {
        "dblclick": function($event) {
          line.property !== 'postalCode' ? _vm.filterPrefill('ALL_VALUES', line.property, true) : ''
        },
        "focus": function($event) {
          line.property === 'postalCode' || (_vm.country === 'AT' && line.property === 'line3') ? _vm.filtering = null : _vm.filterPrefill(_vm.country === 'UK' && _vm.formData[line.property] === '' ? 'ALL_VALUES' : _vm.formData[line.property], line.property)
        },
        "input": function($event) {
          ['postalCode', 'line1'].includes(line.property) ? _vm.getPrefill(_vm.formData.postalCode, $event, line.property) : _vm.filterPrefill($event, line.property)
        },
        "blur": function($event) {
          ['line2'].includes(line.property) && _vm.formData[line.property] !== '' ? _vm.replaceAddress(_vm.formData[line.property], line.property) : ''
        }
      },
      model: {
        value: (_vm.formData[line.property]),
        callback: function($$v) {
          _vm.$set(_vm.formData, line.property, $$v)
        },
        expression: "formData[line.property]"
      }
    }), _vm._v(" "), (!(_vm.country === 'AT' && line.property === 'line3') &&
      _vm.filtering === line.property &&
      _vm.prefill.filtered.length > 0) ? _c('ul', _vm._l((_vm.filterUniqueFields(_vm.prefill.filtered, line.property)), function(filtered, index) {
      return _c('li', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.replaceAddress(filtered, line.property)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.country === 'UK' ? _vm.generateAddress(filtered) : filtered) + "\n              ")])
    }), 0) : _vm._e(), _vm._v(" "), (line.property === 'postalCode' &&
      _vm.filtering === line.property &&
      _vm.postalCodes.length > 0) ? _c('ul', _vm._l((_vm.postalCodes), function(filtered, index) {
      return _c('li', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.setPostalCode(filtered)
          }
        }
      }, [_vm._v("\n                " + _vm._s(filtered) + "\n              ")])
    }), 0) : _vm._e(), _vm._v(" "), (
      _vm.filtering === line.property &&
      _vm.prefill.filtered.length > 0) ? _c('div', {
      staticClass: "focus-mask",
      on: {
        "click": function($event) {
          _vm.filtering = null
        }
      }
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "warning",
      "value": _vm.err !== ''
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.save) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad3cbaba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddressModal.vue
// module id = 596
// module chunks = 7